import {React, useHistory, useCallback, useContext} from 'external/react'
import {clsx, styled, Box, Select, MenuItem, ArrowDropDownIcon, FAIcon} from 'external/material'

import {TeacherContext} from 'teacher/context'

const StyledSelectGroup = styled(Box)(groupStyles)

export default function SelectGroup () {

  const history = useHistory()
  const {link, linkQuery, groups, groupId} = useContext(TeacherContext)

  const handleGroupChange = useCallback(event => {
    history.push(linkQuery(link({groupId: event.target.value}), {}))
  }, [])
  
  const group  = groups.length > 0 && groupId == undefined ? groups[0].id : groupId
  const value = groups.length == 0 || group == undefined ? '' : group

  return (
    <StyledSelectGroup>
      <Box className={clsx('container', 'icon')}>
        <FAIcon icon="users" />
      </Box>
      <Box className={clsx('container', 'select')}>
        <Select onChange={handleGroupChange} value={value} IconComponent={ArrowDropDownIcon}>
          {groups.map(group => (<MenuItem value={group.id} key={group.id}>{group.name}</MenuItem>))}
        </Select>
      </Box>
    </StyledSelectGroup>
  )
}

function groupStyles() {
  return {
    display: 'flex',
    color: '#4f576e',
    fontWeight: 'bold',
    '&:focus': {
      backgroundColor: 'transparent'
    },
    "& .container": {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      "&.icon": {
        color: '#4f576e',
        fontWeight: 'bold',
        color: '#3295ce',
        width: '50px !important',
        fontSize: 24,
        marginRight: 12
      },
      "&.select": {
        "& > .MuiInputBase-root": {
          width: 250,
          height: 40
        },
        '& .MuiInput-underline:before': {
          content: 'none',
          border: 'none'
        },
        '& .MuiInput-underline:after': {
          content: 'none',
          border: 'none'
        }
      },
    },
  }
}

